import React, { ReactNode, useState } from 'react';

import { Button, ButtonProps } from "@material-ui/core";

import { ConfirmDialog, OmittedConfirmDialogProps } from "../confirm_dialog";

export interface ConfirmButtonWithDialogProps extends ButtonProps {
  dialogProps: OmittedConfirmDialogProps;
  dialogContent: ReactNode;
  onConfirm: () => void;
  onUndo: () => void;
  Component?: React.FC<{
    onClick: () => void
  }>;
}

export function ConfirmButtonWithDialog(props: ConfirmButtonWithDialogProps) {
  const { 
    Component, children, onConfirm, onUndo, onClick, dialogContent, 
    dialogProps, ...buttonProps
  } = props;

  const [open, setOpen] = useState(false);

  const onButtonClick = () => {
    setOpen(true);
  }

  return (
    <>
      {Component && (
        <Component onClick={() => onButtonClick()}>
          {children}
        </Component>
      )}
      {!Component && (
        <Button 
          {...buttonProps}
          onClick={() => onButtonClick()}
        >
          {children}
        </Button>
      )}
      <ConfirmDialog
        dialogProps={dialogProps}
        open={open}
        setOpen={setOpen}
        onConfirm={onConfirm}
        onUndo={onUndo}
      >
        {dialogContent}
      </ConfirmDialog>
    </>
  )
}
